import {AbstractControl} from '@angular/forms';
/**
 * @param {?} c
 * @return {?}
 */
export function consistOfArrays(c: AbstractControl) {

  if (c.value) {
    const /** @type {?} */ arrayConstructor = [].constructor;

    const /** @type {?} */ error = {
      consistOfArrays: {
        numOfItemsThatAreNoArray: 0,
        message: 'Signature don\'t consist of arrays'
      }
    };

    if (c.value.constructor !== arrayConstructor) {
      return null;
    }

    const /** @type {?} */ countOfNonArrays =
      c.value.filter(function (i) {
        // filter non arrays
        return i.constructor !== arrayConstructor;
      }).length;

    // return error if a non array is contained
    if (countOfNonArrays > 0) {
      error.consistOfArrays.numOfItemsThatAreNoArray = countOfNonArrays;
      return error;
    }
    return null;
  }
  return null;
}
